var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isMobile
    ? _c(
        "rb-panel",
        {
          attrs: { visible: _vm.visible },
          on: { closed: _vm.close },
          scopedSlots: _vm._u(
            [
              {
                key: "title",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "klarna-afterpay--title text-uppercase" },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(_vm.$t("pay_over_time.content.title")) +
                            "\n    "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            2064596877
          ),
        },
        [
          _vm._v(" "),
          _c("rb-pay-over-time-panel", {
            directives: [
              {
                name: "scroll-lock",
                rawName: "v-scroll-lock",
                value: _vm.visible,
                expression: "visible",
              },
            ],
          }),
        ],
        1
      )
    : _c("rb-pay-over-time-modal", {
        attrs: { visible: _vm.visible, prices: _vm.prices },
        on: { closed: _vm.close },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }